import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../services/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
               // this.authenticationService.logout();
                //location.reload();
            }

            // Preservar la estructura completa del error para que los componentes puedan acceder al mensaje
            // Si err.error es un objeto con message, error y statusCode, preservarlo completo
            if (err.error && typeof err.error === 'object' && err.error.message) {
                return throwError(() => err);
            }
            
            // Si err.error es un string (responseType: 'text'), intentar parsearlo
            if (err.error && typeof err.error === 'string') {
                try {
                    const parsedError = JSON.parse(err.error);
                    if (parsedError.message) {
                        // Reconstruir el error con la estructura parseada
                        err.error = parsedError;
                        return throwError(() => err);
                    }
                } catch (e) {
                    // Si no se puede parsear, mantener el error original
                }
            }

            // Si no hay estructura de error, devolver el error completo para preservar la información
            return throwError(() => err);
        }));
    }
}
